/**
 * iOS WebKit only (Safari + Chrome + other iOS browsers): native `controls`
 * always paint Apple’s full-frame black dim (iOS 18+) — CSS cannot clear it.
 * Keep every Chrome-equivalent control via a custom bar that matches Chrome’s
 * layout (play | time | scrubber | mute | PiP | fullscreen | more) without
 * that system dim. Desktop Chrome/other browsers keep Liquid native controls.
 * Sound unlock lives in ambient-video-sound.js.
 */
(function () {
  if (window.__laboIosAmbientVideo) return;
  window.__laboIosAmbientVideo = true;

  var SELECTOR = 'video.project-video, video.mhb__asset';

  function isIosWebKit() {
    var ua = navigator.userAgent || '';
    var iOS =
      /iPhone|iPad|iPod/i.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    return iOS && /AppleWebKit/i.test(ua);
  }

  window.laboAmbientIsIosWebKit = isIosWebKit;

  if (!isIosWebKit()) return;

  function injectStyles() {
    if (document.getElementById('labo-ios-av-styles')) return;
    var style = document.createElement('style');
    style.id = 'labo-ios-av-styles';
    // Chrome-like bottom transport only — no full-frame dim overlay.
    style.textContent =
      '.ios-av-wrap{position:relative;width:100%;height:100%}' +
      '.ios-av-wrap>video{width:100%}' +
      '@media screen and (max-width:749px){' +
      '.ios-av-wrap:has(>video.project-video-desktop){display:none!important}' +
      '}' +
      '@media screen and (min-width:750px){' +
      '.ios-av-wrap:has(>video.project-video-mobile){display:none!important}' +
      '}' +
      '.ios-av-bar{' +
      'opacity:0;visibility:hidden;pointer-events:none;' +
      'transition:opacity .15s ease,visibility .15s ease;z-index:2;' +
      'position:absolute;left:0;right:0;bottom:0;' +
      'display:flex;flex-wrap:nowrap;align-items:center;gap:6px;' +
      'padding:10px 10px 8px;box-sizing:border-box;' +
      'background:linear-gradient(to top,rgba(0,0,0,.65) 0%,rgba(0,0,0,.35) 55%,transparent 100%)' +
      '}' +
      '.ios-av-wrap.is-controls-visible .ios-av-bar{' +
      'opacity:1;visibility:visible;pointer-events:auto' +
      '}' +
      '.ios-av-bar__btn{' +
      'flex:0 0 auto;width:32px;height:32px;padding:0;margin:0;' +
      'border:0;border-radius:0;background:transparent;color:#fff;' +
      'appearance:none;-webkit-appearance:none;cursor:pointer' +
      '}' +
      '.ios-av-bar__btn[hidden]{display:none!important}' +
      '.ios-av-bar__btn svg{width:20px;height:20px;margin:auto;pointer-events:none;fill:currentColor}' +
      '.ios-av-bar__time{' +
      'flex:0 0 auto;color:#fff;white-space:nowrap;' +
      'font:500 12px/1 -apple-system,BlinkMacSystemFont,system-ui,sans-serif;' +
      'font-variant-numeric:tabular-nums;' +
      'user-select:none;-webkit-user-select:none' +
      '}' +
      '.ios-av-bar__seek{' +
      'flex:1 1 auto;min-width:0;height:28px;margin:0 4px;padding:0;' +
      'accent-color:#fff;-webkit-appearance:none;appearance:none;' +
      'background:transparent' +
      '}' +
      '.ios-av-bar__seek::-webkit-slider-runnable-track{' +
      'height:3px;background:rgba(255,255,255,.4)' +
      '}' +
      '.ios-av-bar__seek::-webkit-slider-thumb{' +
      '-webkit-appearance:none;width:12px;height:12px;margin-top:-4.5px;' +
      'border-radius:50%;background:#fff' +
      '}';
    document.head.appendChild(style);
  }

  function formatTime(seconds) {
    if (!isFinite(seconds) || seconds < 0) return '0:00';
    var total = Math.floor(seconds);
    var s = total % 60;
    var m = Math.floor(total / 60) % 60;
    var h = Math.floor(total / 3600);
    var ss = s < 10 ? '0' + s : String(s);
    if (h > 0) {
      var mm = m < 10 ? '0' + m : String(m);
      return h + ':' + mm + ':' + ss;
    }
    return m + ':' + ss;
  }

  function iconPlay() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
  }

  function iconPause() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 5h4v14H6zm8 0h4v14h-4z"/></svg>';
  }

  function iconMute() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16.5 12a4.5 4.5 0 0 0-2.5-4V16a4.5 4.5 0 0 0 2.5-4zm2.5 0c0 2.5-1.4 4.7-3.5 5.8v2.1A7.5 7.5 0 0 0 21.5 12 7.5 7.5 0 0 0 15.5 4.1v2.1c2.1 1.1 3.5 3.3 3.5 5.8zM3 9v6h4l5 5V4L7 9H3z"/></svg>';
  }

  function iconUnmute() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16.5 12a4.5 4.5 0 0 0-2.5-4v2.2l2.4 2.4c.07-.2.1-.4.1-.6zm2.5 0c0 .9-.2 1.7-.5 2.5l1.5 1.5A7.4 7.4 0 0 0 21.5 12a7.5 7.5 0 0 0-6-7.4v2.1c2.1 1.1 3.5 3.3 3.5 5.8zM4.3 3 3 4.3 7.7 9H3v6h4l5 5v-6.7l4.7 4.7 1.3-1.3L4.3 3zM14 8.8v-.8L9.8 12H14V8.8z"/></svg>';
  }

  function iconAirplay() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 22h12l-6-7-6 7zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/></svg>';
  }

  function iconPip() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 11h-8v6h8v-6zm4-6H1v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14z"/></svg>';
  }

  function iconFullscreen() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>';
  }

  function iconMore() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/></svg>';
  }

  function makeBtn(className, label, html) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ios-av-bar__btn ' + className;
    btn.setAttribute('aria-label', label);
    btn.innerHTML = html;
    return btn;
  }

  function stripNativeControls(video) {
    if (!video) return;
    video.controls = false;
    video.removeAttribute('controls');
  }

  function enhance(video) {
    if (!video || video.dataset.iosAv === '1') return;
    video.dataset.iosAv = '1';

    stripNativeControls(video);
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('x-webkit-airplay', 'allow');
    if ('disableRemotePlayback' in video) {
      try {
        video.disableRemotePlayback = false;
      } catch (e) {}
    }

    var parent = video.parentElement;
    if (!parent) return;

    var wrap = video.closest('.ios-av-wrap, .ambient-av-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'ios-av-wrap';
      if (video.classList.contains('project-video-desktop')) {
        wrap.classList.add('project-video-desktop');
      }
      if (video.classList.contains('project-video-mobile')) {
        wrap.classList.add('project-video-mobile');
      }
      parent.insertBefore(wrap, video);
      wrap.appendChild(video);
    } else {
      wrap.classList.add('ios-av-wrap');
    }

    // Chrome order: play | current / duration | scrubber | mute | pip | fs | more
    var bar = document.createElement('div');
    bar.className = 'ios-av-bar';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Video controls');

    var playBtn = makeBtn(
      'ios-av-bar__play',
      video.paused ? 'Play' : 'Pause',
      video.paused ? iconPlay() : iconPause()
    );

    var timeEl = document.createElement('span');
    timeEl.className = 'ios-av-bar__time';
    timeEl.setAttribute('aria-live', 'off');
    timeEl.textContent = '0:00 / 0:00';

    var seek = document.createElement('input');
    seek.type = 'range';
    seek.className = 'ios-av-bar__seek';
    seek.min = '0';
    seek.max = '1000';
    seek.value = '0';
    seek.setAttribute('aria-label', 'Seek');

    var muteBtn = makeBtn(
      'ios-av-bar__mute',
      video.muted ? 'Unmute' : 'Mute',
      video.muted ? iconUnmute() : iconMute()
    );

    var canPip =
      typeof video.webkitSetPresentationMode === 'function' ||
      (document.pictureInPictureEnabled && typeof video.requestPictureInPicture === 'function');
    var pipBtn = makeBtn('ios-av-bar__pip', 'Picture in Picture', iconPip());
    if (!canPip) pipBtn.hidden = true;

    var canFs =
      typeof video.webkitEnterFullscreen === 'function' ||
      typeof video.requestFullscreen === 'function';
    var fsBtn = makeBtn('ios-av-bar__fs', 'Fullscreen', iconFullscreen());
    if (!canFs) fsBtn.hidden = true;

    var canAirplay = typeof video.webkitShowPlaybackTargetPicker === 'function';
    var moreBtn = makeBtn('ios-av-bar__more', 'More options', iconMore());
    if (!canAirplay) moreBtn.hidden = true;

    bar.appendChild(playBtn);
    bar.appendChild(timeEl);
    bar.appendChild(seek);
    bar.appendChild(muteBtn);
    bar.appendChild(pipBtn);
    bar.appendChild(fsBtn);
    bar.appendChild(moreBtn);
    wrap.appendChild(bar);

    var hideTimer = null;
    var seeking = false;

    function showControls() {
      wrap.classList.add('is-controls-visible');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        if (!seeking) wrap.classList.remove('is-controls-visible');
      }, 4000);
    }

    function syncPlayUi() {
      var paused = video.paused;
      playBtn.setAttribute('aria-label', paused ? 'Play' : 'Pause');
      playBtn.innerHTML = paused ? iconPlay() : iconPause();
    }

    function syncMuteUi() {
      muteBtn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
      muteBtn.innerHTML = video.muted ? iconUnmute() : iconMute();
    }

    function syncTimeUi() {
      timeEl.textContent =
        formatTime(video.currentTime) + ' / ' + formatTime(video.duration);
      if (seeking || !video.duration || !isFinite(video.duration)) return;
      seek.value = String(Math.round((video.currentTime / video.duration) * 1000));
    }

    playBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (video.paused) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
      showControls();
    });

    muteBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (video.muted) {
        if (typeof window.laboAmbientUnlockSound === 'function') {
          window.laboAmbientUnlockSound(video).then(syncMuteUi);
        } else {
          try {
            video.defaultMuted = false;
          } catch (err) {}
          video.muted = false;
          video.removeAttribute('muted');
          try {
            video.volume = 1;
          } catch (err2) {}
          video.play().catch(function () {});
          syncMuteUi();
        }
      } else if (typeof window.laboAmbientMuteSound === 'function') {
        window.laboAmbientMuteSound(video);
        syncMuteUi();
      } else {
        video.muted = true;
        video.setAttribute('muted', '');
        syncMuteUi();
      }
      showControls();
    });

    seek.addEventListener('pointerdown', function (e) {
      e.stopPropagation();
      seeking = true;
      showControls();
    });
    seek.addEventListener(
      'touchstart',
      function (e) {
        e.stopPropagation();
        seeking = true;
        showControls();
      },
      { passive: true }
    );

    seek.addEventListener('input', function (e) {
      e.stopPropagation();
      if (!video.duration || !isFinite(video.duration)) return;
      video.currentTime = (Number(seek.value) / 1000) * video.duration;
      syncTimeUi();
      showControls();
    });

    seek.addEventListener('change', function () {
      seeking = false;
      showControls();
    });
    seek.addEventListener('pointerup', function () {
      seeking = false;
      showControls();
    });

    pipBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      try {
        if (typeof video.webkitSetPresentationMode === 'function') {
          var mode = video.webkitPresentationMode;
          video.webkitSetPresentationMode(
            mode === 'picture-in-picture' ? 'inline' : 'picture-in-picture'
          );
        } else if (document.pictureInPictureElement === video) {
          document.exitPictureInPicture();
        } else if (video.requestPictureInPicture) {
          video.requestPictureInPicture();
        }
      } catch (err) {}
      showControls();
    });

    fsBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      try {
        if (typeof video.webkitEnterFullscreen === 'function') {
          video.webkitEnterFullscreen();
        } else if (video.requestFullscreen) {
          video.requestFullscreen();
        }
      } catch (err) {}
      showControls();
    });

    moreBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      try {
        if (canAirplay) video.webkitShowPlaybackTargetPicker();
      } catch (err) {}
      showControls();
    });

    if (canAirplay) {
      video.addEventListener('webkitplaybacktargetavailabilitychanged', function (evt) {
        moreBtn.hidden = !(evt && evt.availability === 'available');
      });
    }

    function stopBubble(e) {
      e.stopPropagation();
    }
    bar.addEventListener('click', stopBubble);
    bar.addEventListener('touchstart', stopBubble, { passive: true });

    wrap.addEventListener('click', function (e) {
      if (e.target.closest('.ios-av-bar')) return;
      stripNativeControls(video);
      showControls();
    });
    wrap.addEventListener(
      'touchstart',
      function () {
        stripNativeControls(video);
      },
      { passive: true }
    );

    video.addEventListener('play', syncPlayUi);
    video.addEventListener('pause', syncPlayUi);
    video.addEventListener('volumechange', syncMuteUi);
    video.addEventListener('timeupdate', syncTimeUi);
    video.addEventListener('loadedmetadata', syncTimeUi);
    video.addEventListener('durationchange', syncTimeUi);
    video.addEventListener('play', function () {
      stripNativeControls(video);
    });

    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(function () {
        if (video.hasAttribute('controls') || video.controls) {
          stripNativeControls(video);
        }
      });
      mo.observe(video, { attributes: true, attributeFilter: ['controls'] });
    }

    syncPlayUi();
    syncMuteUi();
    syncTimeUi();
  }

  function enhanceAll() {
    injectStyles();
    document.querySelectorAll(SELECTOR).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }
})();
